module.exports = __webpack_public_path__ + "img/geometric.242f0d13.png";